module.exports = __webpack_public_path__ + "static/media/Vector.419ee63b.svg";